import React, { useState, useEffect } from "react";
import faradayApi from "../../Services/faradayApi";
import "../Client/style.css";
import "../../Components/CoustCardRow/style.css";
import { formatCNPJ } from "../../utils/utilityFunctions";
import { Spinner } from "react-bootstrap";
import { ContainerArea } from "../ClientDashboard/styled";
import DashboardPageLayout from "../../Components/Dashboard/DashboardPageLayout";

const CompanyDashboard = () => {
  const [companyData, setCompanyData] = useState<any>();
  const [profiles, setProfiles] = useState<any[] | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const affiliateId = localStorage.getItem("affiliateId");
      const companyResponse = await faradayApi.get(`companies/${affiliateId}`);
      if (companyResponse) {
        const measuringPointsResponse = await faradayApi.get(
          `companies/${affiliateId}/measuring-points-by-initials`
        );
        const measuringPoints = measuringPointsResponse.data.measuringPoints;
        if (companyResponse.data.status === "EM_ADESAO") {
          await faradayApi.get(
            `measuring-point/public/${measuringPoints[0].id}`
          );
        }
        setCompanyData(companyResponse.data);
        setProfiles(measuringPoints);
      }
    };
    try {
      fetchData();
    } catch (e) {
      console.error(e);
    }
  }, []);

  if (!companyData) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}
      >
        <ContainerArea>
          <Spinner
            className="text-secondary"
            animation="border"
            variant="secondary"
          />
        </ContainerArea>
      </div>
    );
  }

  return (
    <DashboardPageLayout
      title="Cliente indicado"
      showBackButton
      partnerInfoProps={{
        nome: companyData?.name,
        sigla: companyData?.initials,
        email: "",
        cnpj: formatCNPJ(companyData?.cnpj),
        inicioLivre: companyData?.start_acl,
        logo: companyData?.logo,
        parterInfosTotal: companyData,
        canEdit: false,
      }}
      companyId={companyData?.id}
      cnpj={companyData?.cnpj}
      profiles={profiles}
      companyData={companyData}
      showCharts={companyData?.status === "ATIVO"}
      showMigrationMessage={companyData?.status !== "ATIVO"}
    />
  );
};

export default CompanyDashboard;
